import React, { useEffect, useState } from "react";
import { CircularProgress, Backdrop } from "@mui/material";
import Layout from "../components/Layout";
import { getAllCourses, getAllUpgradedLARForAdmin } from "../service/service";
import CourseReviewGrid from "../components/CourseReviewGrid";

const ReviewUpgradedLAR = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [LARCounts, setLARCounts] = useState({});

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const data = await getAllCourses();
        setCourses(data.data);
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  // Fetch LAR counts and update the badge when courses change
  useEffect(() => {
    if (!courses.length) return;

    const fetchAllLARs = async () => {
      try {
        // Create an object mapping course IDs to their LAR counts
        const counts = Object.fromEntries(
          await Promise.all(
            courses.map(async (course) => [
              course._id,
              (await getAllUpgradedLARForAdmin(course._id, course.name)).length,
            ]),
          ),
        );
        setLARCounts(counts);
      } catch (error) {
        console.error("Failed to fetch LARs:", error);
      }
    };

    fetchAllLARs();
  }, [courses]);

  return (
    <Layout>
      {loading ? (
        <Backdrop open={loading} sx={{ zIndex: 1 }}>
          <CircularProgress />
        </Backdrop>
      ) : (
        <CourseReviewGrid
          title="Upgraded LAR"
          description="Review upgraded learner audio by course."
          courses={courses}
          counts={LARCounts}
          actionLabel="Review LAR"
          to={(course) => `/upgraded-lar/${course._id}/${course.name}`}
        />
      )}
    </Layout>
  );
};

export default ReviewUpgradedLAR;
